export default "__VITE_ASSET__0a72a709__"